const CONST = {
  API: {
    ROUTE: {
      BASE_URL: process.env.VUE_APP_API_URL,
      DRAWING: {
        CREATE: '/drawings'
      },
      INVENTION: {
        CREATE: '/inventions'
      },
      CONTENT: '/invention/',
      MESSAGE: {
        PUSH: '/messages'
      },
      EMAIL: {
        SEND: '/share/email'
      },
      SMS: {
        SEND: '/share/sms'
      }
    },
    EXCEPTION: {
      VALIDATION_ERROR: 404,
      AUTH_EXPIRED: 402,
      INVALID_LOGIN: 401
    }
  },
  CMS: {
    ROUTE: {
        INVENTION: '/invention/'
    }
  },
  ROUTE: {
    START: "/start",
    DRAW: "/draw",
    INVENT: "/invent"
  },
  EVENT: {
    DRAWING: {
      CREATED: 'drawing-created',
      SENT: 'drawing-sent',
      STOPPED: 'drawing-stopped'
    },
    INVENTION: {
      STOPPED: 'invention-stopped'
    },
    QUEUE: {
      UPDATED: 'queue-updated'
    }
  },
  KEY: {
    REQUEST: {
      AUTHORIZATION: 'Authorization',
      BEARER: 'Bearer ',
      ACCEPT: 'Accept',
      CONTENT_TYPE: 'Content-Type',
      APP_KEY: 'Application-Key',
      APP_SECRET: 'Application-Secret',
      ACCESS_CONTROL_ALLOW_ORIGIN: 'Access-Control-Allow-Origin',
      ACCESS_CONTROL_ALLOW_CREDENTIALS: 'Access-Control-Allow-Credentials'
    }
  },
  VALUE: {
    ENV: {
      DEVELOPMENT: 'development',
      STAGING: 'staging',
      PRODUCTION: 'production'
    },
    REQUEST: {
      ACCEPT_JSON: 'application/json',
      ACCEPT_MULTIPART: "multipart/form-data",
      ACCESS_CONTROL_ALLOW_ORIGIN: '*',
      ACCESS_CONTROL_ALLOW_CREDENTIALS: 'true'
    },
    COLORS: {
      'green': '#6cd440',
      'aqua': '#71fbea',
      'blue': '#1d5cf6',
      'purple': '#7f2af5',
      'fuchsia': '#d339f6',
      'red': '#ec3326',
      'orange': '#FF5800',
      'yellow': '#fdef50',
      'black': '#000000',
      'white': '#FFFFFF'
    },
    LINE_WIDTHS: {
      'xs': 5,
      'sm': 10,
      'md': 15,
      'lg': 20,
      'xl': 25
    },
    PUSHER: {
      CHANNEL: 'drawings'
    }
  }
};
export default CONST;
